import { useCallback, useState, useRef } from "react";

import TextInput, { TextInputProps } from "./TextInput";
import { MaskedTextInput, TextInputIcon } from "../../../components";
import { Platform, TextInput as NativeTextInput } from "react-native";

const SSN_TOGGLE_ID = "toggle-ssn";

function validFocusBlurEvent(e: any) {
  return Platform.OS !== "web" || e?.relatedTarget?.id !== SSN_TOGGLE_ID;
}

export default function SSNInput(props: TextInputProps) {
  const [showSSN, _setShowSSN] = useState(false);
  const firstChangeAfterShow = useRef(false);

  function setShowSSN(bool: boolean) {
    _setShowSSN(bool);
    firstChangeAfterShow.current = bool;
  }

  const onChange = (onChangeText?: (text: string, raw: string) => void) => (text: string, raw: string) => {
    // HACK:: event fires with "" on first render, crashing into an
    // infinite re-render loop. Used a ref to ignore the first event.
    if (Platform.OS !== "web" || !firstChangeAfterShow.current) onChangeText?.(text, raw);
    firstChangeAfterShow.current = false;
  };

  const toDots = (value?: string) => [...Array((value || "").length)].map(() => "\u2022").join("");

  const maskedInputRef = useCallback(
    (el: NativeTextInput | null) => {
      if (el && showSSN) {
        el.focus();
      }
    },
    [showSSN]
  );

  return (
    <TextInput
      {...props}
      render={({ onChangeText, onBlur, onFocus, ref, value, testID, ...props }) =>
        showSSN ? (
          <MaskedTextInput
            {...props}
            {...{ value, testID }}
            ref={(el) => {
              ref(el);
              maskedInputRef(el);
            }}
            onBlur={(e) => {
              if (validFocusBlurEvent(e)) {
                setShowSSN(false);
              }
              onBlur?.(e);
            }}
            className="flex-1 text-regular font-400"
            keyboardType="number-pad"
            mask="999-99-9999"
            textContentType="none"
            onChangeText={onChange(onChangeText)}
          />
        ) : (
          <NativeTextInput
            ref={ref}
            value={toDots(value)}
            testID={`${testID}-secure`}
            onFocus={(e) => {
              if (validFocusBlurEvent(e)) {
                setShowSSN(true);
              }
            }}
            textContentType="none"
            className="flex-1 text-regular font-400 ml-4"
          />
        )
      }
      right={
        <TextInputIcon
          // @ts-ignore set element id for the web
          nativeID={SSN_TOGGLE_ID}
          focusable={false}
          icon={showSSN ? "eye-off" : "eye"}
          testID={`${props.testID}-toggle`}
          onPress={() => {
            setShowSSN(!showSSN);
          }}
        />
      }
    />
  );
}
